export default __webpack_public_path__ + "static/media/Server.b2c6631b.png";